import React, { useEffect, useState, useRef } from "react";

import { Form, Spinner } from "react-bootstrap";

import { Formik } from "formik";
import "./search-button.scss";
import FluentUiIcon from "../../assets/fluent-ui-icon";

// routing
import { useHistory, useLocation } from "react-router-dom";

// redux
import { connect } from "react-redux";
import {
  setSearchInput,
  setSearchResult,
  searchLoadingStart,
  getSearchResults,
} from "../../redux/search/search.actions";
import { createStructuredSelector } from "reselect";
import {
  selectSearchInput,
  selectSearchResult,
  selectLoadingSearch,
  selectSearchResultSorted,
} from "../../redux/search/search.selector";

// components
import SearchResult from "../search-result/SearchResult";
import { selectUser } from "../../redux/user/user-selector";
import NoPermissionsPanel from "../no-permissions-panel/no-permissions-panel";

const hideMenuSearch = window["APP_SETTINGS"].HIDE_MENU_SEARCH;

const SearchButton = ({
  user: { privileges },
  setSearchInput,
  searchInput,
  loading,
  getSearchResults,
  searchResultSorted,
  searchLoadingStart,
  setHideNavItems,
}) => {
  let history = useHistory();
  let location = useLocation();

  let delayTimer;

  const [showNoPermissions, setShowNoPermissions] = useState(false);

  const node = useRef(); //for closing the dropdown
  const pillInputRef = useRef(null);
  const allButtonRef = useRef(null);
  const closeButtonRef = useRef(null);

  const [showResults, setShowResults] = useState(false); //dropdown controls

  const [input, setInput] = useState("");

  const [clicked, setClicked] = useState(false);

  const [isSearchPage, setIsSearchPage] = useState(false);
  const [isFocusedOnSearch, setIsFocusedOnSearch] = useState(false);

  const handleChangeInputChange = (e) => {
    if (e.length !== 1) {
      setInput(e);
    }
  };

  const handleClick = (e) => {
    if (node?.current?.contains(e.target)) {
      if (
        privileges &&
        privileges["Search"] &&
        privileges["Search"].View === false
      ) {
        setShowNoPermissions(true);
        return;
      }

      setClicked(true);
      return;
    }
    setClicked(false);
  };

  const handleClickResult = (link) => {
    setShowResults(false);
    setClicked(false);

    if (location.pathname.includes(link)) window.location.reload();
    else history.push(link);
  };

  const handleSubitSearch = (values) => {
    if (values.searchInput.length < 2) return;

    setInput(values.searchInput);

    setClicked(false);

    if (location.pathname.includes("/searchresults/all")) {
      clearTimeout(delayTimer);

      setTimeout(() => {
        setShowResults(true);
        getSearchResults(values.searchInput);
      }, 0);
    } else {
      clearTimeout(delayTimer);

      setTimeout(() => {
        setShowResults(true);
        getSearchResults(values.searchInput);
      }, 0);

      history.push("/searchresults/all");
    }
  };

  const clearSearch = (resetForm) => {
    let values = {
      searchInput: "",
    };
    resetForm(values);
    setSearchInput("");
    setInput("");
  };

  useEffect(() => {
    if (input.length >= 2 && clicked) {
      searchLoadingStart();

      delayTimer = setTimeout(() => {
        setShowResults(true);
        getSearchResults(input);
      }, 1200);

      return () => clearTimeout(delayTimer);
    }
  }, [input]);

  useEffect(() => {
    if (!location.pathname.includes("search-results")) {
      setIsSearchPage(false);
      setInput("");
    } else {
      setIsSearchPage(true);
    }

    if (
      privileges &&
      privileges["Search"] &&
      privileges["Search"].View === true
    ) {
      document.addEventListener("mousedown", handleClick);
    }
    
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, []);

  const hidePermission = () => {
    setShowNoPermissions(false);
  };

  const focusInput = () => {
    pillInputRef.current.focus();
  };

  const handleAllButtonClick = (values) => {
    handleSubitSearch(values);
  };

  const handleClose = (resetForm) => {
    clearSearch(resetForm);
  };

  //Disable clicking of button once pill is opened -> Fixes potential unnecessary rerenders and removes applying different styles to chrome and firefox
  const clickDisabler = (e) => {
    if (isFocusedOnSearch) {
      e.preventDefault();
    }
  };

  return (
    hideMenuSearch === null ||
    (hideMenuSearch !== null && hideMenuSearch !== "TRUE" && (
      <div
        className={`search-element ${
          isFocusedOnSearch ? "search-element-opened" : ""
        }`}
      >
        {showNoPermissions && (
          <NoPermissionsPanel
            show={showNoPermissions}
            onHide={() => hidePermission()}
            message={"You dont have permission to use this feature"}
          />
        )}

        <Formik
          initialValues={{ searchInput: isSearchPage ? searchInput : input }}
          onSubmit={(values) => handleSubitSearch(values)}
          enableReinitialize={true}
        >
          {({ values, handleSubmit, handleChange, resetForm }) => (
            <Form onSubmit={handleSubmit} style={{ width: "100%" }}>
              <div className="search-button" ref={node}>
                <button
                  type="button"
                  onMouseDown={(e) => clickDisabler(e)}
                  onFocus={() => {
                    setIsFocusedOnSearch(true);
                    setHideNavItems(true);
                  }}
                  onBlur={() => {
                    setIsFocusedOnSearch(false);
                    setHideNavItems(false);
                    setInput("");
                  }}
                  className={`${isFocusedOnSearch ? "opened" : "default"}-pill`}
                >
                  <div className="magnifying-icon">
                    <FluentUiIcon name="SearchRegular" size={20} color="#616161" />
                  </div>
                  {
                    <input
                      ref={pillInputRef}
                      className={`search-input-${
                        isFocusedOnSearch ? "visible" : "hidden"
                      }`}
                      type="text"
                      name="searchInput"
                      autoComplete="off"
                      placeholder="Search"
                      value={values.searchInput}
                      onMouseDown={focusInput}
                      onChange={(e) => {
                        handleChange(e);
                        handleChangeInputChange(e.target.value);
                      }}
                      onBlur={() => {
                        setInput("");
                      }}
                    ></input>
                  }
                  <div className="search-flex-container">
                    <div
                      ref={closeButtonRef}
                      className={`search-close-icon-${
                        values.searchInput.length > 0 && isFocusedOnSearch
                          ? "visible"
                          : "hidden"
                      }`}
                      id="close-icon"
                      onMouseDown={() => handleClose(resetForm)}
                    ></div>
                    <div
                      className={`all-button-${
                        isFocusedOnSearch ? "visible" : "hidden"
                      }`}
                      onMouseDown={() => handleAllButtonClick(values)}
                      ref={allButtonRef}
                    >
                      All
                      {/* <img className={`all-button-arrow`} alt='dropdown-arrow' src={DropdownArrow}/> */}
                    </div>
                  </div>
                </button>
              </div>
            </Form>
          )}
        </Formik>

        {input.length > 0 &&
          showResults === true &&
          clicked === true &&
          (loading ? (
            <table className="search-result-table">
              <tbody>
                <tr>
                  <td>
                    <Spinner animation="border" variant="primary" size="sm" />{" "}
                  </td>
                </tr>
              </tbody>
            </table>
          ) : (
            <table className="search-result-table">
              {searchResultSorted.wordDocs.length < 1 &&
              searchResultSorted.excelDocs.length < 1 &&
              searchResultSorted.pptDocs.length < 1 &&
              searchResultSorted.tasks.length < 1 &&
              searchResultSorted.projects.length < 1 ? (
                <tbody>
                  <tr>
                    <td>
                      <span>No results found for '{input}'</span>
                    </td>
                  </tr>
                </tbody>
              ) : null}

              {searchResultSorted.wordDocs.length > 0 ? (
                <tbody
                  onMouseDown={() =>
                    handleClickResult(`/searchresults/docx?${input}`)
                  }
                >
                  <SearchResult
                    type="Docx"
                    input={input}
                    length={searchResultSorted.wordDocs.length}
                  />
                </tbody>
              ) : null}

              {searchResultSorted.excelDocs.length > 0 ? (
                <tbody
                  onMouseDown={() =>
                    handleClickResult(`/searchresults/excel?${input}`)
                  }
                >
                  <SearchResult
                    type="Excel"
                    input={input}
                    length={searchResultSorted.excelDocs.length}
                  />
                </tbody>
              ) : null}

              {searchResultSorted.pptDocs.length > 0 ? (
                <tbody
                  onMouseDown={() =>
                    handleClickResult(`/searchresults/ppt?${input}`)
                  }
                >
                  <SearchResult
                    type="PPT"
                    input={input}
                    length={searchResultSorted.pptDocs.length}
                  />
                </tbody>
              ) : null}

              {searchResultSorted.tasks.length > 0 ? (
                <tbody
                  onMouseDown={() =>
                    handleClickResult(`/searchresults/task?${input}`)
                  }
                >
                  <SearchResult
                    type="Task"
                    input={input}
                    length={searchResultSorted.tasks.length}
                  />
                </tbody>
              ) : null}

              {searchResultSorted.projects.length > 0 ? (
                <tbody
                  onMouseDown={() =>
                    handleClickResult(`/searchresults/project?${input}`)
                  }
                >
                  <SearchResult
                    type="Project"
                    input={input}
                    length={searchResultSorted.projects.length}
                  />
                </tbody>
              ) : null}
            </table>
          ))}
      </div>
    ))
  );
};

const mapState = createStructuredSelector({
  user: selectUser,
  searchInput: selectSearchInput,
  searchResult: selectSearchResult,
  searchResultSorted: selectSearchResultSorted,
  loading: selectLoadingSearch,
});

const mapDispatch = (dispatch) => ({
  setSearchInput: (searchInput) => dispatch(setSearchInput(searchInput)),
  searchLoadingStart: () => dispatch(searchLoadingStart()),
  getSearchResults: (input) => dispatch(getSearchResults(input)),
  setSearchResult: (result) => dispatch(setSearchResult(result)),
});

export default connect(mapState, mapDispatch)(SearchButton);
